"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockTheme = exports.mockBreakpoints = exports.mockLighthouseTermBorderAttributes = exports.mockHorizontalRuleBorderAttributes = exports.mockBuyBoxButtonBorderAttributes = exports.mockBuyBoxBorderAttributes = exports.mockSpacings = exports.mockPriceLabelFont = exports.mockMediumFont = exports.mockBaseFont = exports.mockLighthouseTerm = exports.mockBuyBoxButtonPalette = exports.mockFontPalette = void 0;
const lodash_1 = require("lodash");
const merge_1 = __importDefault(require("lodash/merge"));
const theme_1 = require("../../theme");
exports.mockFontPalette = {
    primary: '#0F1111',
    base: '#0F1111',
    secondary: '#565959',
    instantly: '#009900',
    price: '#B12704',
    link: '#007185',
    linkHover: '#c45500',
    productHeader: '#cc6600'
};
exports.mockBuyBoxButtonPalette = {
    foreground: '#111',
    background: 'linear-gradient(to bottom, #f7dfa5, #f0c14b)',
    backgroundHover: 'linear-gradient(to bottom, #f5d78e, #eeb933)'
};
exports.mockLighthouseTerm = {
    foreground: '#111111',
    background: '#D7E8EA'
};
exports.mockBaseFont = {
    fontFamily: '"Amazon Ember", Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '13px',
    lineHeight: '19px'
};
exports.mockMediumFont = {
    fontFamily: '"Amazon Ember", Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '24px'
};
exports.mockPriceLabelFont = {
    fontFamily: '"Amazon Ember", Arial, sans-serif',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px'
};
exports.mockSpacings = {
    xs: '5px',
    sm: '10px',
    md: '20px',
    lg: '40px',
    xl: '60px',
    xxl: '80px',
    xxxl: '100px'
};
exports.mockBuyBoxBorderAttributes = {
    border: '1px #ddd solid',
    borderRadius: '4px'
};
exports.mockBuyBoxButtonBorderAttributes = {
    border: '1px solid',
    borderColor: '#a88734 #9c7e31 #846a29',
    borderRadius: '2px'
};
exports.mockHorizontalRuleBorderAttributes = {
    borderTop: '1px solid #e7e7e7'
};
exports.mockLighthouseTermBorderAttributes = {
    borderBottom: 'solid 1px #969696'
};
exports.mockBreakpoints = {
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
};
exports.mockTheme = (0, merge_1.default)((0, lodash_1.cloneDeep)(theme_1.moneraTheme), {
    palettes: {
        font: exports.mockFontPalette,
        buyBoxButton: exports.mockBuyBoxButtonPalette,
        lighthouseTerm: exports.mockLighthouseTerm
    },
    typography: {
        base: exports.mockBaseFont,
        md: exports.mockMediumFont,
        priceLabel: exports.mockPriceLabelFont
    },
    spacings: exports.mockSpacings,
    borders: {
        buyBox: exports.mockBuyBoxBorderAttributes,
        buyBoxButton: exports.mockBuyBoxButtonBorderAttributes,
        horizontalRule: exports.mockHorizontalRuleBorderAttributes,
        lightHouseTerm: exports.mockLighthouseTermBorderAttributes
    },
    breakpoints: exports.mockBreakpoints
});
